/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { postRequestOptions, getRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'

interface UnitCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	idUnits: number | null;
	unitName: string;
}


const UnitCreate: React.FC<UnitCreateProps> = ({ show, handleClose, id }) => {


	const initialState: InitialState = {
		idUnits: 0,
		unitName: '',
	};

	const [unit, setUnit] = useState(initialState);


	useEffect(() => {

	}, [])

	useEffect(() => {
		if (id === 0) {
			setUnit({ idUnits: null, unitName: '' });

		} else {
			fetch(
				process.env.REACT_APP_API_URL + 'units/edit/' + id,
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					setUnit({ idUnits: resp.data.id_units, unitName: resp.data.unit_name });
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}
	}, [id]);


	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setUnit({ ...unit, [e.target.name]: e.target.value });
	};

	const unitSave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to " + (id === 0 ? "create" : "update") + " this Unit?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(unit)
			try {

				let url = (id === 0) ? `${process.env.REACT_APP_API_URL}units/store` : `${process.env.REACT_APP_API_URL}units/update`

				let response = await fetch(
					url,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				setLoading(false);
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		}
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={unitSave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create' : 'Edit'} Unit</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="unitName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Name <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="unitName" id="unitName" value={unit.unitName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					{/* <pre>{JSON.stringify(company, null, 2)}</pre> */}
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default UnitCreate
